import EventEmitter from 'event-emitter-es6';

const container = {
    getInstance(Name) {
        if (!this[Name]) {
            this[Name] = new Name(container);
            return this[Name];
        }
        return this[Name];
    },
    get eventEmitter() {
        return this.getInstance(EventEmitter);
    }
};

export function createContext() {
    return container;
}
